import * as actionTypes from './actionTypes';

export const initBandwidthStart = (days) => {
  return {
    type: actionTypes.INIT_BANDWIDTH_START,
    days: days,
  };
};
export const resetBandwidthState = () => {
  return {
    type: actionTypes.RESET_BANDWIDTH_STATE,
    
  };
}
export const refreshBandwidth = () => {
  return window.location.reload();
};
export const setBandwidth = (realBandwidth) => {
  return {
    type: actionTypes.SET_BANDWIDTH,
    realBandwidth: realBandwidth,
  };
};

export const fetchBandwidthFailed = () => {
  return {
    type: actionTypes.FETCH_BANDWIDTH_FAILED,
  };
};

export const initBandwidth = (days) => {
  return {
    type: actionTypes.INIT_BANDWIDTH,
    days: days || 7,
  };
};
